export default __webpack_public_path__ + "static/media/hacker1-en.ba6b176f.png";